<template>
  <router-view/>
</template>


<style lang="scss">
@import '@style/index.scss';


</style>
